import { useMutation as useSearchSuggestionsDeleteQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/search/empty-page-suggestions/post-hooks";
import { logError } from "@faire/web/common/logging";
import { createToast } from "@faire/web/slate/Toast/Toast";

const useDeleteSearchSuggestionQuery = () => {
  const { mutate: deleteSearchSuggestion } = useSearchSuggestionsDeleteQuery({
    onError: (error) => {
      logError(error);
      createToast(error.message, {
        variant: "destructive",
        timeout: "long",
      });
    },
  });

  return { deleteSearchSuggestion };
};

export default useDeleteSearchSuggestionQuery;
